// extracted by mini-css-extract-plugin
export var clickThrough = "_yi-2";
export var fallback = "_yi-5";
export var frame = "_yi-3";
export var frameCell = "_yi-1";
export var overlay = "_yi-4";
export var wrapper = "_yi-0";